import './faq.component.scss'
import { Spoiler } from '../../application/core/spoiler';

const spoilers = [...document.querySelectorAll('.js-spoiler')]
if (spoilers.length > 0) {
	new Spoiler(spoilers)
}

